import { AccountData, AccountStatus, StageType } from './types';

export const D = 864e5;

export const STATUS_COLORS: Record<AccountStatus, string> = {
  Normal: '#3FA34D',
  Attention: '#F2C230',
  Paused: '#E0463C',
  Recovery: '#B8BCC2',
  'Scale Ready': '#9A6A2A'
};

export const STAGE_STYLE: Record<StageType, [string, string]> = {
  Demo: ['#4B5563', '#F1F2F5'],
  Challenge: ['#A8660B', '#FFF1DA'],
  Verified: ['#8A5A0B', '#FBE7C2'],
  Funded: ['#1F7A6E', '#DDF1EE'],
  Unclassified: ['#B42318', '#FEECEB']
};

